var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1.0.0"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["controle-de-saldo-frontend@digix"]={id:"1.0.0"};
      


// WEBPACK FOOTER //
// ./~/@sentry/webpack-plugin/src/sentry-webpack.module.js